<template>
  <v-app-bar app color="white">
    <div class="d-flex align-center">
      <a href="https://www.rrr.or.jp" target="_blank" rel="noopener">
        <v-img :src="require('../assets/logo_rrr.png')" height="50" :width="titleWidth" contain />
      </a>
      <v-img :src="require('../assets/cross.png')" :height="crossHeight" contain></v-img>
      <a href="https://www.enerbank.co.jp" target="_blank" rel="noopener">
        <v-img :src="require('../assets/enerbank_logo.png')" height="50" :width="titleWidth" contain />
      </a>
    </div>

    <v-spacer></v-spacer>
    <v-btn color="info" class="font-weight-black text-body-1 hidden-sm-and-down" href="https://form.run/@rrr-eneoku/">
      問い合わせ
    </v-btn>
    <v-btn
      color="error"
      class="margin-left font-weight-black text-body-1 hidden-sm-and-down"
      href="https://rrr.auctions.enerbank.co.jp"
      target="_blank"
      rel="noopener"
    >
      無料登録
    </v-btn>
  </v-app-bar>
</template>

<script>
export default {
  computed: {
    titleWidth() {
      if (this.$vuetify.breakpoint.xsOnly) return 100
      return 250
    },
    crossHeight() {
      if (this.$vuetify.breakpoint.xsOnly) return 20
      return 40
    },
  },
}
</script>

<style scoped>
.margin-left {
  margin-left: 10px;
}
</style>
